import { defineMessages } from 'react-intl';

export default defineMessages({
  sent_failure: {
    id: 'kustomer.chat.conversation.message.failure',
    description: 'Hover title for failed message',
    defaultMessage: 'Failed to send message, click to retry',
  },
});
